/**
 * Send a Slack notification when a new issue is created.
 * Uses the notify-slack Edge Function to avoid CORS (Slack webhooks block browser requests).
 * Fire-and-forget: does not throw or block on failure.
 */
export async function notifySlackNewIssue(supabase, issue, customerName) {
	try {
		await supabase.functions.invoke('notify-slack', {
			body: { issue, customerName }
		})
	} catch (err) {
		console.warn('Slack notification failed:', err)
	}
}
